import script from "./cardData.vue?vue&type=script&lang=ts&setup=true"
export * from "./cardData.vue?vue&type=script&lang=ts&setup=true"

import "./cardData.vue?vue&type=style&index=0&id=0fe8a5c8&scoped=true&lang=stylus"

import exportComponent from "D:\\project\\web\\vysa_wifi_h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fe8a5c8"]])

export default __exports__